import { render, staticRenderFns } from "./CartPage.vue?vue&type=template&id=4596ad43&"
import script from "./CartPage.vue?vue&type=script&lang=ts&"
export * from "./CartPage.vue?vue&type=script&lang=ts&"
import style0 from "./CartPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports